import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminRoute from "./Routes/Admin.Routes";
import UserRoute from "./Routes/User.Routes";
import SuperAdminRoute from "./Routes/SuperAdmin.Routes";
import SubAdminRoutes from "./Routes/SubAdmin.Routes";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PermissionContext } from "./PermissionContext";
import Home from "./Home";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const Role = localStorage.getItem("Role");
  const { permissionData } = useContext(PermissionContext);

  useEffect(() => {
    // Agar user login nahi hai aur route protected nahi hai to kuch mat karo
    // if (location.pathname === "/login" || location.pathname === "/register") return;

    // Agar koi bhi route blank ya "/" hai to home dikhao
    if (location.pathname === "/") {
      navigate("/home");
      return;
    }

    // Agar user login nahi hai aur koi aur route khol raha hai
    if ((!Role || Role === "null") && location.pathname == "/login" ) {
 
      navigate("/login");
      return;
    }
  if ((!Role || Role === "null") && location.pathname == "/register" ) {
 
      navigate("/register");
      return;
    }
     if (!Role || Role === "null" && location.pathname == "/home" ) {
    
      navigate("/home");
      return;
    }
   if (!Role || Role === "null" && location.pathname == "/" ) {
   
      navigate("/");
      return;
    }
    


    // Role ke hisab se redirect karo
    // switch (Role) {
    //   case "Admin":
    //     if (!location.pathname.startsWith("/admin")) {
    //       navigate("/admin/dashboard");
    //     }
    //     break;
    //   case "User":
    //     if (!location.pathname.startsWith("/user")) {
    //       navigate("/user/dashboard");
    //     }
    //     break;
    //   case "Superadmin":
    //     if (!location.pathname.startsWith("/superadmin")) {
    //       navigate("/superadmin/dashboard");
    //     }
    //     break;
    //   case "Subadmin":
    //     if (!location.pathname.startsWith("/subadmin")) {
    //       navigate("/subadmin/dashboard");
    //     }
    //     break;
    //   default:
    //     break;
    // }
  }, [location.pathname, navigate, Role]);

  return (
    <>
      <Routes>
        {/* Default Home route */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />

        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Role-based routes */}
        <Route
          path="/admin/*"
          element={
            Role === "Admin" ? (
              <AdminRoute permissionData={permissionData} />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/user/*"
          element={
            Role === "User" ? (
              <UserRoute permissionData={permissionData} />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/superadmin/*"
          element={
            Role === "Superadmin" ? (
              <SuperAdminRoute permissionData={permissionData} />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/subadmin/*"
          element={
            Role === "Subadmin" ? (
              <SubAdminRoutes permissionData={permissionData} />
            ) : (
              <Login />
            )
          }
        />
      </Routes>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  );
};

export default App;
